// removed by extract-text-webpack-plugin
module.exports = {"menu":"_7blv8BfueloqXcZ5ju4cG","menu__made-by":"_1yZ9raAKODF31pFSxI-OcJ","menu__items":"_24_dHJLQSfUT0c7h7W0m2J","menu__items_folded":"qFbnXfQ8dj5GZAQD6Y367"};